import BaseApiClient from '../BaseApiClient';
import type { CallEntityType, TwilioInitiateCallResponse } from './twilio-types';

export type { CallEntityType, TwilioInitiateCallResponse } from './twilio-types';

export class ApiTwilio extends BaseApiClient {
  /**
   * Initiate outbound call for a specific entity (individual, task, company, or user)
   * Returns call data and access token
   */
  async initiateCall(
    entityId: string,
    entityType: CallEntityType
  ): Promise<TwilioInitiateCallResponse> {
    return new Promise((resolve, reject) => {
      const headers =
        entityType === 'akoni-index-users'
          ? { Version: '2022-12-23' }
          : undefined;
      this.client
        .post(`/phone/${entityType}/${entityId}`, undefined, { headers })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  }
}

export { useTwilioInitiateCallMutation, type TwilioInitiateCallVariables } from './use-twilio-mutations';

